import React, { useState } from "react";
import "../styles/Pages.css";

function HariPrabodhamDham() {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState("");

  const openVideoModal = (videoId) => {
    setCurrentVideoId(videoId);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setCurrentVideoId("");
  };

  return (
    <div className="page-container">
      <main>
        <div className="content">
          {/* Hero Landing Section */}
          <section className="hero-banner">
            <div className="hero-content">
              <img
                src="/image/dham.jpg"
                alt="Hariprabodham Dham"
                className="hero-image"
              />
            </div>
          </section>

          {/* Hariprabodham Triveni Mahotsav */}
          <section className="pravachan-section" id="pravachan">
            <div className="section-container">
              <div className="section-header">
                <h2 className="section-title">
                  Hariprabodham Triveni Mahotsav
                </h2>
              </div>

              <div className="youtube-cards-container">
                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("G9g3yGITk3E")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/G9g3yGITk3E/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Khatmuhurat</h3>
                    <p className="card-date">6 Oct 2025</p>
                  </div>
                </div>

                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("webAiIXSKjU")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/webAiIXSKjU/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Khatmuhurat</h3>
                    <p className="card-date">6 Oct 2025</p>
                  </div>
                </div>

                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("Gf5XbjEFBMI")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/Gf5XbjEFBMI/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Mahapuja Khatmuhurat Sabha</h3>
                    <p className="card-date">6 Oct 2025</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Hariprabodham Triveni Mahotsav Smruti */}
          <section className="pravachan-section" id="pravachan">
            <div className="section-container">
              <div className="section-header">
                <h2 className="section-title">
                  Hariprabodham Triveni Mahotsav Smruti
                </h2>
              </div>

              <div className="youtube-cards-container">
                <div className="youtube-card">
                  <div className="card-image">
                    <a
                      href="https://smruti.ihariprabodham.in/gallery.php?year=2025&month=10&folder=2025-10-04-BhaktiRally"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://smruti.ihariprabodham.in/2025/10/2025-10-04-BhaktiRally/thumbnail/2025-10-06-04-01.jpg"
                        alt="Dham"
                        className="thumbnail"
                      />
                    </a>
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Bhakti Rally</h3>
                    <p className="card-date">4 Oct 2025</p>
                  </div>
                </div>

                <div className="youtube-card">
                  <div className="card-image">
                    <a
                      href="https://smruti.ihariprabodham.in/gallery.php?year=2025&month=10&folder=2025-10-06-Mahapuja"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://smruti.ihariprabodham.in/2025/10/2025-10-06-Mahapuja/thumbnail/2025-10-06-A-01.jpg"
                        alt="Dham"
                        className="thumbnail"
                      />
                    </a>
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Mahapuja</h3>
                    <p className="card-date">6 Oct 2025</p>
                  </div>
                </div>

                <div className="youtube-card">
                  <div className="card-image">
                    <a
                      href="https://smruti.ihariprabodham.in/gallery.php?year=2025&month=10&folder=2025-10-06-Khatmuhurat"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://smruti.ihariprabodham.in/2025/10/2025-10-06-Khatmuhurat/thumbnail/2025-10-06-01.jpg"
                        alt="Dham"
                        className="thumbnail"
                      />
                    </a>
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Khatmuhurat</h3>
                    <p className="card-date">6 Oct 2025</p>
                  </div>
                </div>

                <div className="youtube-card">
                  <div className="card-image">
                    <a
                      href="https://smruti.ihariprabodham.in/gallery.php?year=2025&month=10&folder=2025-10-06-Sabha"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://smruti.ihariprabodham.in/2025/10/2025-10-06-Sabha/thumbnail/2025-10-06-B-01.jpg"
                        alt="Dham"
                        className="thumbnail"
                      />
                    </a>
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Sabha</h3>
                    <p className="card-date">6 Oct 2025</p>
                  </div>
                </div>

                <div className="youtube-card">
                  <div className="card-image">
                    <a
                      href="https://smruti.ihariprabodham.in/gallery.php?year=2025&month=10&folder=2025-10-06-Baheno"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src="https://smruti.ihariprabodham.in/2025/10/2025-10-06-Baheno/thumbnail/2025-10-06-C01.jpg"
                        alt="Dham"
                        className="thumbnail"
                      />
                    </a>
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Baheno Vibhag</h3>
                    <p className="card-date">6 Oct 2025</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Guruhari Padharamni */}
          <section className="pravachan-section" id="pravachan">
            <div className="section-container">
              <div className="section-header">
                <h2 className="section-title">Guruhari Padharamni</h2>
              </div>

              <div className="youtube-cards-container">
                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("oirnPWesfLc")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/oirnPWesfLc/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Dhun & Pushpanjali</h3>
                    <p className="card-date">May 2025</p>
                  </div>
                </div>

                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("D2dfwcZOM14")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/D2dfwcZOM14/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Announcement</h3>
                    <p className="card-date">Sept 2025</p>
                  </div>
                </div>

                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("XiR5fYLId8U")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/XiR5fYLId8U/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Guruhari Visit</h3>
                    <p className="card-date">Sept 22, 2025</p>
                  </div>
                </div>

                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("xb4U6uxk8hY")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/xb4U6uxk8hY/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Guruhari Visit</h3>
                    <p className="card-date">Sept 27, 2025</p>
                  </div>
                </div>

                <div
                  className="youtube-card"
                  onClick={() => openVideoModal("bx1WisG6Lc8")}
                >
                  <div className="card-image">
                    <img
                      src="https://img.youtube.com/vi/bx1WisG6Lc8/hqdefault.jpg"
                      alt="Dham"
                      className="thumbnail"
                    />
                  </div>
                  <div className="card-content">
                    <h3 className="card-title">Guruhari Visit</h3>
                    <p className="card-date">Oct 2025</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Seva Bhakti & Rally */}
          <section className="pravachan-section" id="pravachan">
            <div className="section-container">
              <div className="section-header">
                <h2 className="section-title">Seva Bhakti & Rally</h2>
              </div>

              <div className="youtube-cards-container">
                {[
                  { id: "vtCJppFut4k", title: "Preparation 1" },
                  { id: "B6AZUY6jPZY", title: "Preparation 2" },
                  { id: "IXcbrDkNRaM", title: "Preparation 3" },
                  { id: "iYKYT8iHkWk", title: "Preparation 4" },
                  { id: "3he51iqVJi8", title: "Preparation 5" },
                  { id: "plgKVW-qXw0", title: "Preparation 6" },
                  { id: "VvdgLB85yT0", title: "Preparation 7" },
                  { id: "JBMJ2VdszDM", title: "Preparation 8" },
                  { id: "8uEd7BSJTZQ", title: "Preparation 9" },
                  { id: "PktqeY699_U", title: "Preparation 10" },
                  { id: "oqXoCqmn21A", title: "Bundle Of Joy" },
                  {
                    id: "dyCKqkIsUjo",
                    title: "Divine Yatra of Shila-Samarpan",
                  },
                  { id: "SsQjHkXcXu8", title: "P. Sarveshwarben Visit" },
                  { id: "qEsxUdhQ10g", title: "Bhakti Rally" },
                  { id: "bdqHg56CzLw", title: "Preparation 11" },
                  { id: "XGf8DZXm2X0", title: "Preparation 12" },
                  { id: "eObUKldUwLE", title: "Preparation 13" },
                  { id: "jG9OhQThG4A", title: "Preparation 14" },
                  { id: "AOTW2owFEwM", title: "Shubh Swagatam" },
                  { id: "5eDRifYwF7w", title: "Avo Mandir Banaye" },
                ].map((video, index) => (
                  <div
                    key={index}
                    className="youtube-card"
                    onClick={() => openVideoModal(video.id)}
                  >
                    <div className="card-image">
                      <img
                        src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                        alt="Dham"
                        className="thumbnail"
                      />
                    </div>
                    <div className="card-content">
                      <h3 className="card-title">{video.title}</h3>
                      <p className="card-date">2025</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* YouTube Modal */}
      {modalOpen && (
        <div id="youtubeModal" className="modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={closeModal}>
              &times;
            </span>
            <div className="iframe-container">
              <iframe
                id="youtubePlayer"
                src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=1`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="YouTube Video"
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HariPrabodhamDham;
